import { queryOptions } from "@tanstack/react-query";
import { listOrganizationAthletes } from "api-client";

import {
  organizationKeys,
  type OrganizationAthletesQueryInput,
} from "./organizations";

export function organizationAthletesQueryOptions(
  organizationId: string,
  input: OrganizationAthletesQueryInput,
) {
  return queryOptions({
    queryKey: organizationKeys.athleteList(organizationId, input),
    async queryFn() {
      const response = await listOrganizationAthletes({
        path: { organizationId },
        query: input,
      });
      return response.data.data;
    },
  });
}
